import { useQuery, useMutation, useQueryClient } from 'react-query';
import { productsAPI } from '../../services/api';
import toast from 'react-hot-toast';

export const useProducts = () => {
  const queryClient = useQueryClient();

  const { data: products, isLoading, error } = useQuery(
    'products',
    async () => {
      const response = await productsAPI.list();
      return response.data.data;
    }
  );

  const createMutation = useMutation(
    (data) => productsAPI.create(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('products');
        toast.success('Product created successfully!');
      },
      onError: (error) => {
        toast.error(error.message || 'Failed to create product');
      },
    }
  );

  const updateMutation = useMutation(
    ({ id, data }) => productsAPI.update(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('products');
        toast.success('Product updated successfully!');
      },
      onError: (error) => {
        toast.error(error.message || 'Failed to update product');
      },
    }
  );

  const deleteMutation = useMutation(
    (id) => productsAPI.delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('products');
        toast.success('Product deleted successfully!');
      },
      onError: (error) => {
        toast.error(error.message || 'Failed to delete product');
      },
    }
  );

  return {
    products,
    isLoading,
    error,
    createProduct: createMutation.mutate,
    updateProduct: updateMutation.mutate,
    deleteProduct: deleteMutation.mutate,
    isCreating: createMutation.isLoading,
    isUpdating: updateMutation.isLoading,
    isDeleting: deleteMutation.isLoading,
  };
};
